import { render, staticRenderFns } from "./InternetBanking.vue?vue&type=template&id=133a99dd"
import script from "./InternetBanking.vue?vue&type=script&lang=js"
export * from "./InternetBanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports